import { render, staticRenderFns } from "./BasicAlert.vue?vue&type=template&id=3445c976&scoped=true&"
import script from "./BasicAlert.vue?vue&type=script&lang=js&"
export * from "./BasicAlert.vue?vue&type=script&lang=js&"
import style0 from "./BasicAlert.vue?vue&type=style&index=0&id=3445c976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445c976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VHover,VIcon,VProgressLinear,VSnackbar})
